import type { ReactNode } from 'react';

import type { RolePriority } from '../api/types';

export function Banner({
  kind = 'info',
  children,
}: {
  kind?: 'info' | 'error' | 'success';
  children: ReactNode;
}) {
  return (
    <div className={`banner ${kind}`} role={kind === 'error' ? 'alert' : undefined}>
      {children}
    </div>
  );
}

export function Card({ title, actions, children }: { title?: string; actions?: ReactNode; children: ReactNode }) {
  return (
    <section className="card">
      {(title || actions) && (
        <header className="spread">
          {title ? <h2 style={{ margin: 0 }}>{title}</h2> : <span />}
          {actions}
        </header>
      )}
      {children}
    </section>
  );
}

export function Empty({ children }: { children: ReactNode }) {
  return <p className="empty">{children}</p>;
}

/**
 * Importance d'un poste, en mots et non en coefficients (brief §17).
 */
export function PriorityBadge({ priority }: { priority: RolePriority }) {
  const label = {
    REQUIRED: 'obligatoire',
    PREFERRED: 'souhaité',
    OPTIONAL: 'optionnel',
  }[priority];
  return <span className={`badge ${priority.toLowerCase()}`}>{label}</span>;
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('fr-FR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
}

export function formatShortDate(iso: string): string {
  return new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' });
}

/**
 * Intitulé d'un événement, ou `null` s'il ne fait que répéter sa date.
 *
 * Les dates créées en série s'appellent « Culte du 04/10/2026 » : afficher
 * cet intitulé à côté de « dimanche 4 octobre » n'apporte rien et allonge
 * chaque ligne, ce qui compte sur un écran de téléphone.
 */
export function secondaryLabel(title: string, iso: string): string | null {
  const numeric = new Date(iso).toLocaleDateString('fr-FR');
  return title.includes(numeric) ? null : title;
}
